const pagesDeviceCatalogAddEn = {
  errorBoundary: {
    reload: 'Reload',
    title: 'Failed to load form',
    unknownError: 'An unknown error occurred',
  },
  form: {
    catalogNameLabel: 'Catalog Name',
    catalogNamePlaceholder: 'Enter catalog name',
    categoryLabel: 'Category',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter description',
    manufacturerLabel: 'Manufacturer',
    manufacturerPlaceholder: 'Enter manufacturer',
    modelLabel: 'Model',
    modelPlaceholder: 'Enter model',
    navigation: {
      common: {
        submitButtonLabel: 'Create Catalog',
      },
      completed: {
        activate: 'Activate',
        activateModal: {
          cancel: 'Cancel',
          confirm: 'Activate',
          description:
            'Once activated, the content cannot be edited. Do you want to proceed?',
          title: 'Activate Catalog Item',
        },
        activateSuccess: 'Catalog has been activated successfully',
        completedBy: 'Completed by:',
        continueAndActivate: 'Continue and Activate',
        goToProfile: 'Go to profile',
        message: 'Saved as draft.',
        result: 'Result',
      },
      steps: {
        basic: {
          catalogNameLabel: 'Catalog Name',
          catalogNamePlaceholder: 'Enter catalog name',
          categoryLabel: 'Category',
          codeLabel: 'Code',
          codePlaceholder: 'Enter code',
          descriptionLabel: 'Description',
          descriptionPlaceholder: 'Enter description',
          manufacturerLabel: 'Manufacturer',
          manufacturerPlaceholder: 'Enter manufacturer',
          modelLabel: 'Model',
          modelNumberLabel: 'Model Number',
          modelNumberPlaceholder: 'Enter model number',
          modelPlaceholder: 'Enter model',
          title: 'Basic',
        },
        battery: {
          batteryDesignCapacityMWhLabel: 'Battery Design Capacity (mWh)',
          batteryDesignCapacityMWhPlaceholder:
            'Enter Battery Design Capacity (mWh)',
          batteryManufactureDateLabel: 'Battery Manufacture Date',
          batteryManufactureDatePlaceholder: 'Enter Battery Manufacture Date',
          batteryManufacturerLabel: 'Battery Manufacturer',
          batteryManufacturerPlaceholder: 'Enter Battery Manufacturer',
          batteryModelNameLabel: 'Battery Model Name',
          batteryModelNamePlaceholder: 'Enter Battery Model Name',
          batteryPresenceLabel: 'Battery Present',
          batterySerialNumberLabel: 'Battery Serial Number',
          batterySerialNumberPlaceholder: 'Enter Battery Serial Number',
          batteryTypeLabel: 'Battery Type',
          batteryTypePlaceholder: 'Enter Battery Type',
          title: 'Battery',
        },
        firmware: {
          biosLockWriteProtectionLabel: 'BIOS Lock Write Protection',
          biosPasswordSetLabel: 'BIOS Password Set',
          biosReleaseDateLabel: 'BIOS Release Date',
          biosReleaseDatePlaceholder: 'Select BIOS Release Date',
          biosRomSizeBytesLabel: 'BIOS ROM Size (Bytes)',
          biosRomSizeBytesPlaceholder: 'Enter BIOS ROM Size in Bytes',
          biosUpdateEnabledLabel: 'BIOS Update Enabled',
          biosVendorLabel: 'BIOS Vendor',
          biosVendorPlaceholder: 'Enter BIOS Vendor',
          biosVersionLabel: 'BIOS Version',
          biosVersionPlaceholder: 'Enter BIOS Version',
          bootSequenceOrderLabel: 'Boot Sequence / Order',
          bootSequenceOrderPlaceholder: 'Enter Boot Sequence or Order',
          firmwareModeLabel: 'Firmware Mode',
          firmwareModePlaceholder: 'Enter Firmware Mode',
          firmwareTypeLabel: 'Firmware Type',
          firmwareTypePlaceholder: 'Enter Firmware Type',
          hardwareEncryptionSupportLabel: 'Hardware Encryption Support',
          intelTrustedExecutionTechnologyLabel:
            'Intel Trusted Execution Technology',
          motherboardModelLabel: 'Motherboard Model',
          motherboardModelPlaceholder: 'Enter Motherboard Model',
          oemBiosCustomizationLabel: 'OEM BIOS Customization',
          oemBiosCustomizationPlaceholder: 'Enter OEM BIOS Customization',
          pxeBootEnabledLabel: 'PXE Boot Enabled',
          secureBootEnabledLabel: 'Secure Boot Enabled',
          smbiosVersionLabel: 'SMBIOS Version',
          smbiosVersionPlaceholder: 'Enter SMBIOS Version',
          systemManufacturerLabel: 'System Manufacturer',
          systemManufacturerPlaceholder: 'Enter System Manufacturer',
          systemModelLabel: 'System Model',
          systemModelPlaceholder: 'Enter System Model',
          systemSerialNumberLabel: 'System Serial Number',
          systemSerialNumberPlaceholder: 'Enter System Serial Number',
          systemUuidLabel: 'System UUID',
          systemUuidPlaceholder: 'Enter System UUID',
          title: 'BIOS/Firmware',
          tpmEnabledLabel: 'TPM Enabled',
          tpmVersionLabel: 'TPM Version',
          tpmVersionPlaceholder: 'Enter TPM Version',
          wakeOnLanEnabledLabel: 'Wake-on-LAN Status',
        },
        gpu: {
          gpuArchitectureLabel: 'GPU Architecture',
          gpuArchitecturePlaceholder: 'Enter GPU Architecture',
          gpuClockSpeedBaseHzLabel: 'Clock Speed Base (Hz)',
          gpuClockSpeedBaseHzPlaceholder: 'Enter Clock Speed Base (Hz)',
          gpuClockSpeedBoostHzLabel: 'Clock Speed Boost (Hz)',
          gpuClockSpeedBoostHzPlaceholder: 'Enter Clock Speed Boost (Hz)',
          gpuCudaCoresLabel: 'CUDA Cores',
          gpuCudaCoresPlaceholder: 'Enter CUDA Cores',
          gpuDedicatedMemoryBytesLabel: 'Dedicated Memory (Bytes)',
          gpuDedicatedMemoryBytesPlaceholder: 'Enter Dedicated Memory (Bytes)',
          gpuDriverProviderLabel: 'Driver Provider',
          gpuDriverProviderPlaceholder: 'Enter Driver Provider',
          gpuDriverVersionLabel: 'Driver Version',
          gpuDriverVersionPlaceholder: 'Enter Driver Version',
          gpuGenerationLabel: 'GPU Generation',
          gpuGenerationPlaceholder: 'Enter GPU Generation',
          gpuHardwareAccelerationLabel: 'Hardware Acceleration Enabled',
          gpuMaxDisplaySupportLabel: 'Max Display Support',
          gpuMaxDisplaySupportPlaceholder: 'Enter Max Display Support',
          gpuModelNumberLabel: 'GPU Model Number',
          gpuModelNumberPlaceholder: 'Enter GPU Model Number',
          gpuNameLabel: 'GPU Name',
          gpuNamePlaceholder: 'Enter GPU Name',
          gpuShaderUnitsLabel: 'Shader Units',
          gpuShaderUnitsPlaceholder: 'Enter Shader Units',
          gpuSharedMemoryBytesLabel: 'Shared Memory (Bytes)',
          gpuSharedMemoryBytesPlaceholder: 'Enter Shared Memory (Bytes)',
          gpuSupportedApisLabel: 'Supported APIs',
          gpuSupportedApisPlaceholder: 'Enter Supported APIs',
          gpuVendorLabel: 'GPU Vendor',
          gpuVendorPlaceholder: 'Enter GPU Vendor',
          title: 'GPU',
        },
        monitor: {
          activePortUsedLabel: 'Active Port Used',
          activePortUsedPlaceholder: 'Enter Active Port Used',
          aspectRatioLabel: 'Aspect Ratio',
          aspectRatioPlaceholder: 'Enter Aspect Ratio',
          brightnessLabel: 'Brightness',
          brightnessPlaceholder: 'Enter Brightness',
          colorGamutLabel: 'Color Gamut',
          colorGamutPlaceholder: 'Enter Color Gamut',
          contrastRatioLabel: 'Contrast Ratio',
          contrastRatioPlaceholder: 'Enter Contrast Ratio',
          displayArrangementLabel: 'Display Arrangement',
          displayArrangementPlaceholder: 'Enter Display Arrangement',
          displayTypeLabel: 'Display Type',
          displayTypePlaceholder: 'Enter Display Type',
          inputPortsLabel: 'Input Ports',
          inputPortsPlaceholder: 'Enter Input Ports',
          manufactureDateLabel: 'Manufacture Date',
          manufactureDatePlaceholder: 'Enter Manufacture Date',
          numberOfColorsLabel: 'Number of Colors',
          numberOfColorsPlaceholder: 'Enter Number of Colors',
          panelTypeLabel: 'Panel Type',
          panelTypePlaceholder: 'Enter Panel Type',
          refreshRateHzLabel: 'Refresh Rate (Hz)',
          refreshRateHzPlaceholder: 'Enter Refresh Rate (Hz)',
          resolutionHeightLabel: 'Resolution Height',
          resolutionHeightPlaceholder: 'Enter Resolution Height',
          resolutionWidthLabel: 'Resolution Width',
          resolutionWidthPlaceholder: 'Enter Resolution Width',
          rotationPivotModeLabel: 'Rotation/Pivot Mode',
          rotationPivotModePlaceholder: 'Enter Rotation/Pivot Mode',
          sizeInInchLabel: 'Size (Inch)',
          sizeInInchPlaceholder: 'Enter Size (Inch)',
          title: 'Monitor',
          touchCapabilityLabel: 'Touch Capability',
          touchCapabilityPlaceholder: 'Enter Touch Capability',
        },
        os: {
          antivirusSoftwareCompatibilityLabel:
            'Antivirus Software Compatibility',
          antivirusSoftwareCompatibilityPlaceholder:
            'Enter Antivirus Software Compatibility',
          architectureLabel: 'Architecture',
          architecturePlaceholder: 'Enter Architecture',
          automaticUpdatesEnabledLabel: 'Automatic Updates Enabled',
          bitnessLabel: 'Bitness',
          bitnessPlaceholder: 'Enter Bitness',
          buildNumberLabel: 'Build Number',
          buildNumberPlaceholder: 'Enter Build Number',
          firewallStatusLabel: 'Firewall Status',
          firewallStatusPlaceholder: 'Enter Firewall Status',
          kernelVersionLabel: 'Kernel Version',
          kernelVersionPlaceholder: 'Enter Kernel Version',
          operatingSystemTypeLabel: 'Operating System Type',
          operatingSystemTypePlaceholder: 'Enter Operating System Type',
          osEditionLabel: 'OS Edition',
          osEditionPlaceholder: 'Enter OS Edition',
          osNameLabel: 'OS Name',
          osNamePlaceholder: 'Enter OS Name',
          osSupportLifecycleLabel: 'OS Support Lifecycle',
          osSupportLifecyclePlaceholder: 'Enter OS Support Lifecycle',
          osVersionLabel: 'OS Version',
          osVersionPlaceholder: 'Enter OS Version',
          securityPatchDateLabel: 'Security Patch Date',
          securityPatchDatePlaceholder: 'Enter Security Patch Date',
          servicePackPatchLevelLabel: 'Service Pack/Patch Level',
          servicePackPatchLevelPlaceholder: 'Enter Service Pack/Patch Level',
          title: 'Operating System',
          withVirtualOsLabel: 'With Virtual OS',
        },
        osSetting: {
          bootModeLabel: 'Boot Mode',
          bootModePlaceholder: 'Enter Boot Mode',
          diskEncryptionEnabledLabel: 'Disk Encryption Enabled',
          osInstallDateLabel: 'OS Install Date',
          osInstallDatePlaceholder: 'Enter OS Install Date',
          title: 'OS Setting',
        },
        port: {
          numOfPortsLabel: 'Number of Ports',
          numOfPortsPlaceholder: 'Enter number of ports',
          specificationLabel: 'Specification',
          specificationPlaceholder: 'Enter port specification',
          title: 'Port Information',
          typeLabel: 'Port Type',
          typePlaceholder: 'Select port type',
        },
        processor: {
          cpuCacheSizeL1BytesLabel: 'CPU L1 Cache Size (Bytes)',
          cpuCacheSizeL1BytesPlaceholder: 'Enter CPU L1 Cache Size (Bytes)',
          cpuCacheSizeL2BytesLabel: 'CPU L2 Cache Size (Bytes)',
          cpuCacheSizeL2BytesPlaceholder: 'Enter CPU L2 Cache Size (Bytes)',
          cpuCacheSizeL3BytesLabel: 'CPU L3 Cache Size (Bytes)',
          cpuCacheSizeL3BytesPlaceholder: 'Enter CPU L3 Cache Size (Bytes)',
          cpuClockSpeedHzLabel: 'CPU Clock Speed (Hz)',
          cpuClockSpeedHzPlaceholder: 'Enter CPU Clock Speed (Hz)',
          cpuCoreCountLabel: 'CPU Core Count',
          cpuCoreCountPlaceholder: 'Enter CPU Core Count',
          cpuGenerationLabel: 'CPU Generation',
          cpuGenerationPlaceholder: 'Enter CPU Generation',
          cpuMaxTurboFrequencyHzLabel: 'CPU Max Turbo Frequency (Hz)',
          cpuMaxTurboFrequencyHzPlaceholder:
            'Enter CPU Max Turbo Frequency (Hz)',
          cpuNameLabel: 'CPU Name',
          cpuNamePlaceholder: 'Enter CPU Name',
          cpuProcessNodeLabel: 'CPU Process Node',
          cpuProcessNodePlaceholder: 'Enter CPU Process Node',
          cpuSeriesLabel: 'CPU Series',
          cpuSeriesPlaceholder: 'Enter CPU Series',
          cpuSocketTypeLabel: 'CPU Socket Type',
          cpuSocketTypePlaceholder: 'Enter CPU Socket Type',
          cpuTdpWattLabel: 'CPU TDP (Watt)',
          cpuTdpWattPlaceholder: 'Enter CPU TDP (Watt)',
          cpuThreadCountLabel: 'CPU Thread Count',
          cpuThreadCountPlaceholder: 'Enter CPU Thread Count',
          cpuVendorLabel: 'CPU Vendor',
          cpuVendorPlaceholder: 'Enter CPU Vendor',
          title: 'CPU',
        },
        ram: {
          ramEccSupportedLabel: 'ECC Supported',
          ramFormFactorLabel: 'RAM Form Factor',
          ramFormFactorPlaceholder: 'Enter RAM Form Factor',
          ramGenerationLabel: 'Memory Type',
          ramGenerationPlaceholder: 'Enter Memory Type',
          ramJedecCompliantLabel: 'JEDEC Compliant',
          ramManufactureDateLabel: 'RAM Manufacture Date',
          ramManufactureDatePlaceholder: 'Enter RAM Manufacture Date',
          ramManufacturerLabel: 'RAM Manufacturer',
          ramManufacturerPlaceholder: 'Enter RAM Manufacturer',
          ramPartNumberLabel: 'RAM Part Number',
          ramPartNumberPlaceholder: 'Enter RAM Part Number',
          ramRegisteredLabel: 'Registered RAM',
          ramSerialNumberLabel: 'RAM Serial Number',
          ramSerialNumberPlaceholder: 'Enter RAM Serial Number',
          ramSizeBytesLabel: 'RAM Size (Bytes)',
          ramSizeBytesPlaceholder: 'Enter RAM Size (Bytes)',
          ramSpeedHzLabel: 'RAM Speed (Hz)',
          ramSpeedHzPlaceholder: 'Enter RAM Speed (Hz)',
          title: 'RAM',
        },
        storage: {
          capacityMBLabel: 'Capacity (MB)',
          capacityMBPlaceholder: 'Enter capacity in MB',
          nameLabel: 'Product Name / Model',
          namePlaceholder: 'Enter product name or model name',
          storageCacheSizeBytesLabel: 'Cache Size (Bytes)',
          storageCacheSizeBytesPlaceholder: 'Enter cache size in bytes',
          storageFirmwareVersionLabel: 'Firmware Version',
          storageFirmwareVersionPlaceholder: 'Enter firmware version',
          storageFormFactorLabel: 'Form Factor',
          storageFormFactorPlaceholder: 'Enter form factor',
          storageInterfaceTypeLabel: 'Interface Type',
          storageInterfaceTypePlaceholder: 'Enter interface type',
          storageManufacturerLabel: 'Manufacturer',
          storageManufacturerPlaceholder: 'Enter manufacturer',
          storageNandTypeLabel: 'NAND Type',
          storageNandTypePlaceholder: 'Enter NAND type',
          storageSerialNumberLabel: 'Serial Number',
          storageSerialNumberPlaceholder: 'Enter serial number',
          storageSlotNumberLabel: 'Slot Number',
          storageSlotNumberPlaceholder: 'Enter slot number',
          storageTrimSupportLabel: 'TRIM Support',
          storageTrimSupportPlaceholder: 'Is TRIM supported?',
          title: 'Storage',
          typeLabel: 'Storage Type',
          typePlaceholder: 'Select storage type',
        },
      },
    },
    progressbar: {
      filled: 'filled',
      modeSetting: 'Mode Settings',
      mustItem: 'Must Item',
      mustItemOnly: 'Must item only',
      total: 'Total',
    },
    submitButtonLabel: 'Create Catalog',
    title: 'Basic Information',
  },
  intro: {
    body: {
      fillOutDetails: 'Fill Out Details',
      itemCard: {
        catalogName: 'Catalog Name',
        deviceCategory: 'Category',
        requiredDetails: 'Required:',
      },
      selectDeviceType: 'Select Device Type',
    },
    header: {
      headerTitle: 'Create Device Catalog',
    },
  },
};

export default pagesDeviceCatalogAddEn;
